const RECAPTCHA_SECRET = process.env.MIX_RECAPTCHA_SECRET;
const RECAPTCHA_SITEKEY = process.env.MIX_RECAPTCHA_SITEKEY;

export { RECAPTCHA_SECRET, RECAPTCHA_SITEKEY };
